<template>
  <div id="app">
    <LoadingComponent />
    <div id="nav">
      <Header/>
      <SearchComponent/>
    </div>
    <router-view/>
    <div id="top_page_back">
      <router-link :to="{name:'home'}">トップページへ</router-link>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import SearchComponent from './components/SearchComponent'
import LoadingComponent from './components/LoadingComponent'
export default {
  components:{
    Header,
    Footer,
    SearchComponent,
    LoadingComponent
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 1080px;
  margin:auto;
}
#nav {
  padding: 10px 10px 10px 10px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
#app a{
  color:#157DF0;
}
#top_page_back{
  margin:24px 24px 0 24px;
  text-align: center;
  font-size: 1.3em;
  font-weight: bold;
}
</style>
